import { cloneElement } from 'react'
import { MoreHorizontal24Filled } from '@fluentui/react-icons'
import {
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@opoint/infomedia-storybook'
import { Trans } from 'react-i18next'

import { getActiveNavigationSection, NavOption } from '../../../../helpers/navigation'

type MoreNavigationSection = {
  isExpanded: boolean
  options: NavOption[]
}

export const MoreNavigationSection = ({ isExpanded, options }: MoreNavigationSection) => {
  const activeSection = getActiveNavigationSection()
  const isMoreActive = options.some((option) => option.id === activeSection)

  return (
    <li>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger
          className={cn(
            'peer flex h-11 w-full items-center gap-x-3 px-4 py-[0.3125] text-title text-sky.1 hover:bg-grey.7 hover:text-sky.1 focus:ring-0 focus-visible:bg-grey.7 focus-visible:text-sky.1 data-[state=open]:bg-grey.7',
            { 'bg-grey.7': isMoreActive },
          )}
          data-cy="MoreNavigationSection-button"
        >
          <MoreHorizontal24Filled className="shrink-0" />
          {isExpanded && <Trans>More</Trans>}
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end" side="right" className="w-max min-w-40">
          {options.map(({ component, id }) => (
            <DropdownMenuItem asChild key={id}>
              {/* Overriding isExpanded to always show titles when element is in popover menu */}
              {cloneElement(component, { isExpanded: true })}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </li>
  )
}
